import React from 'react';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
const cityData = [{
  city: 'New York City',
  state: 'NY',
  slug: 'new-york-city',
  count: '1.2M+'
}, {
  city: 'Los Angeles',
  state: 'CA',
  slug: 'los-angeles',
  count: '950K+'
}, {
  city: 'Chicago',
  state: 'IL',
  slug: 'chicago',
  count: '680K+'
}, {
  city: 'Houston',
  state: 'TX',
  slug: 'houston',
  count: '540K+'
}, {
  city: 'Phoenix',
  state: 'AZ',
  slug: 'phoenix',
  count: '420K+'
}, {
  city: 'Philadelphia',
  state: 'PA',
  slug: 'philadelphia',
  count: '390K+'
}, {
  city: 'San Antonio',
  state: 'TX',
  slug: 'san-antonio',
  count: '350K+'
}, {
  city: 'San Diego',
  state: 'CA',
  slug: 'san-diego',
  count: '340K+'
}, {
  city: 'Dallas',
  state: 'TX',
  slug: 'dallas',
  count: '330K+'
}, {
  city: 'Austin',
  state: 'TX',
  slug: 'austin',
  count: '290K+'
}];
export function DatabaseCityLinks() {
  return <section className="py-24 bg-white" data-id="element-1957">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1958">
        <div className="mb-12 text-center" data-id="element-1959">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-1960">
            Local business listings by{' '}
            <span className="text-blue-600" data-id="element-1961">city</span>
          </h2>
          <p className="text-lg text-slate-500 max-w-3xl mx-auto" data-id="element-1962">
            Browse our local business database by location. Find local small
            businesses and access verified business owner emails in your target
            markets.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4" data-id="element-1963">
          {cityData.map(item => <a key={`${item.city}-${item.state}`} href={`https://www.openmart.com/data/${item.slug}`} className="group bg-slate-50 border border-slate-200 rounded-xl p-4 hover:border-blue-300 hover:bg-white hover:shadow-md transition-all" data-id="element-1964">
              <div className="flex items-center gap-2 mb-3" data-id="element-1965">
                <MapPinIcon className="w-4 h-4 text-slate-400 group-hover:text-blue-500 transition-colors flex-shrink-0" data-id="element-1966" />
                <h3 className="font-semibold text-slate-900 text-sm" data-id="element-1967">
                  {item.city}, {item.state}
                </h3>
              </div>

              <div className="flex items-end justify-between" data-id="element-1968">
                <div data-id="element-1969">
                  <div className="text-lg font-bold text-blue-600" data-id="element-1970">
                    {item.count}
                  </div>
                  <div className="text-[10px] font-medium text-slate-500 uppercase tracking-wider" data-id="element-1971">
                    Businesses
                  </div>
                </div>
                <div className="w-6 h-6 rounded-full bg-white border border-slate-200 flex items-center justify-center group-hover:bg-blue-600 group-hover:border-blue-600 transition-colors" data-id="element-1972">
                  <ArrowRightIcon className="w-3 h-3 text-slate-400 group-hover:text-white transition-colors" data-id="element-1973" />
                </div>
              </div>
            </a>)}
        </div>

        <div className="mt-10 text-center" data-id="element-1974">
          <p className="text-sm text-slate-500" data-id="element-1975">
            * Counts represent estimated local businesses currently available in
            the database
          </p>
        </div>
      </div>
    </section>;
}